export enum UserListActionType {
  FETCH_USER_LIST_REQUEST = 'users/FETCH_USER_LIST_REQUEST',
  FETCH_USER_LIST_SUCCESS = 'users/FETCH_USER_LIST_SUCCESS',
  FETCH_USER_LIST_FAILURE = 'users/FETCH_USER_LIST_FAILURE',
}
